
<template>
  <div class="app-container" >
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">操作</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <el-row style="width:100% ;margin-top: 20px">
        <el-col :span=8>
          <el-link href="https://www.baidu.com"  type="primary">孩子数据excel模板下载</el-link>
          <except-excel style=" margin-top: 20px" :title="titleChild"  @onExceptArray="onExceptChildArray"></except-excel>
        </el-col>
        <el-col :span="8">
          <el-link :href="vipExcelTemplateFcUrl" type="primary">亲子游VIP模板下载</el-link>
          <except-excel style=" margin-top: 20px" :title="titleCardFc"  @onExceptArray="onExceptCardArray($event,2)"></except-excel>
        </el-col>
        <el-col :span="8">
          <el-link :href="vipExcelTemplateBsUrl" type="primary">基础游VIP模板下载</el-link>
          <except-excel style=" margin-top: 20px" :title="titleCardBs"  @onExceptArray="onExceptCardArray($event,1)"></except-excel>
        </el-col>
      </el-row>
      <el-card shadow="always" style="margin-top: 30px;" >
        <el-row>
          <el-col :span="8">
            总数量 : {{totalNum}}
          </el-col>
          <el-col :span="8">
            上传成功数 : {{successNum}}
          </el-col>
          <el-col :span="8">
            上传失败数 : {{failNum}}
          </el-col>
        </el-row>
      </el-card>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">错误信息</span>
      </div>
      <div></div>
    </div>
    <el-card class="table-container" style="margin-top: 0px;">
      <el-input
        type="textarea"
        readonly="true"
        :autosize="{ minRows: 15, maxRows: 20}"
        placeholder=""
        v-model="errorInfo">
      </el-input>
    </el-card>

  </div>
</template>

<style>


</style>

<script>


  import ExceptExcel from "../../../components/excel/ExceptExcel";
  import {exportUserBuyCard, exportUserChild} from "../../../api/export";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";
  import {getStaticData} from "../../../api/staticData";
  import commonUtils from "../../../utils/commonUtils";

  export default {
    components:{ExceptExcel},
    data() {
      return {

        vipExcelTemplateFcUrl:"",//亲子游VIP模板下载
        vipExcelTemplateBsUrl:"",//基础游VIP模板下载

        titleChild:"导入客户数据",
        titleCardFc:"导入亲子游会员数据",
        titleCardBs:"导入基础游会员数据",
        timer:null,
        isInexport:false,
        childData:[],
        curExportChildIndex:-1,

        totalNum :0,  //总上传数量
        successNum:0,     //上传成功数量
        failNum :0, //上传失败数量

        errorInfo:"",
        exportType:0, //1 上传孩子数据 2 上传购卡

      }
    },
    created(){
      this.initData();
      this.resetDataStart();
    },
    mounted() {

    },
    methods: {

      initData(){


        getStaticData("").then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.vipExcelTemplateFcUrl = data.vipExcelTemplateFcUrl;
          this.vipExcelTemplateBsUrl = data.vipExcelTemplateBsUrl;
          console.log("getStaticData",this.vipExcelTemplateBsUrl, this.vipExcelTemplateBsUrl)

        })

      },

      resetDataStart(){
        this.curExportChildIndex = -1;
        this.successNum = 0;
        this.failNum = 0;
        this.childData = [];
        clearInterval(this.timer);
        this.timer = null;
        this.isInexport = false;
        this.errorInfo = ""
        this.exportType =0;

      },
      resetDataFinish(){
        this.curExportChildIndex = -1;
        this.childData = [];
        clearInterval(this.timer);
        this.timer = null;
        this.isInexport = false;
        this.exportType =0;

      },
      onExceptChildArray(array){
        if (this.isInexport){
          messageUtils.errorMsg(this,"正在上传数据，请稍后");
          return;
        }
        this.resetDataStart();
        array.map(v => {
          let obj = {}
          obj.name = v['会员姓名']
          obj.petName = v['孩子小名']
          obj.gender = v['性别']
          obj.childBirthday = v['孩子生日']
          obj.height = v['身高']
          obj.weight = v['体重']
          obj.userName = v['家长姓名']
          obj.userPhone = v['家长手机号']
          obj.level = v['孩子等级']
          obj.areaAddress = v['社区']
          obj.storeFrontId = globaldata.getAdminStore().storeFrontId
          this.childData.push(obj)
        })

        this.totalNum = this.childData.length;
        this.errorInfo = "开始上传......." + "\n"
        this.exportType =1;
        this.timerCheckExport();

      },
      onExceptCardArray(array,type){
        if (this.isInexport){
          messageUtils.errorMsg(this,"正在上传数据，请稍后");
          return;
        }
        this.resetDataStart();
        array.map(v => {
          let obj = {}

          obj.childName = v['会员姓名']
          obj.childPetName = v['会员小名']
          obj.childBirthday = v['会员生日']
          obj.gender = v['会员性别']
          obj.level = v['会员等级']
          obj.userName = v['家长姓名']
          obj.userPhone = v['家长手机号']
          obj.address = v['社区']
          obj.storeFrontId = globaldata.getAdminStore().storeFrontId
          obj.cardName = v['卡名称']
          obj.cardBussnessType = v['版本']
          obj.totalClass = v['总正价课时']
          obj.totalGiveClass = v['总赠送课时']
          obj.remainingClass = v['剩余正价课时']
          obj.remainingGiveClass = v['剩余赠送课时']
          obj.valiedDay = v['有效期']
          obj.totalPay = v['家长支付总金额']
          obj.remTotalPay = v['剩余金额']
          obj.useTimes = v['已经使用次数']
          obj.remark = v['备注']
          obj.templateId = type
          this.childData.push(obj)
        })

        this.totalNum = this.childData.length;
        this.errorInfo = "开始上传......." + "\n";
        this.exportType =2;
        this.timerCheckExport();
      },
      timerCheckExport(){
        this.timer =setInterval(this.doExportOne, 100);
      },

      doExportOne(){
        if (this.isInexport == true){
          console.log("正在上传中,请等待")
          return;
        }
        this.curExportChildIndex = this.curExportChildIndex+1;

        if (this.curExportChildIndex >= this.childData.length){
          //完成了
          this.resetDataFinish();
          this.errorInfo += "上传结束......" + '\n'
          return;
        }
        this.isInexport = true;
        let param = this.childData[this.curExportChildIndex];
        if (this.exportType == 1){
          this.onExportUserChild(param);
        }
        else if (this.exportType  ==2){
          this.onExportUserBuyCard(param);
        }


      },


      onExportUserBuyCard(param){
        exportUserBuyCard(param).then(response =>
        {
          let data = response.data;
          if  (data.success == true){
            //上传一条成功
            this.onSuccess();
          }else {
            let  mes = data.error;
            this.onFiled(mes);
          }
          this.isInexport = false;
        })
      },

      onExportUserChild(param){

        exportUserChild(param).then(response =>
        {
          let data = response.data;
          if  (data.success == true){
            //上传一条成功
            this.onSuccess();
          }else {
            let  mes = data.error;
            this.onFiled(mes);
          }
          this.isInexport = false;
        })
      },
      onSuccess(){
        this.successNum +=1;
      },
      onFiled(mes){
        this.errorInfo  = this.errorInfo +  "第 " + (this.curExportChildIndex+1) + " 条" + "上传失败 信息:"  + mes;
        this.errorInfo +="\n"
        this.failNum +=1;
      }

    },


  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/export/index.vue